module.exports = __webpack_public_path__ + "static/img/faq2.02f5602.png";